import { handleUrl, myHeadersWithTokenContentType } from '../../global';
import {
  AnnouncementResponse,
  CreateAnnouncementData,
  DetailProps,
  UpdateAnnouncementData,
} from './types';

export const createAnnouncement = (
  noticeId: number,
  data: CreateAnnouncementData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${noticeId}/announcements`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const listAnnouncements = (
  noticeId: number,
  page: number,
  size: number
): Promise<AnnouncementResponse> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${noticeId}/announcements?page=${page}&size=${size}`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const deleteAnnouncement = (
  announcementId: number
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'DELETE',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/notice-announcements/${announcementId}`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const updateAnnouncement = (
  announcementId: number,
  data: UpdateAnnouncementData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PATCH',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/notice-announcements/${announcementId}`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};
